import {
  List,
  Datagrid,
  EmailField,
  BooleanField,
  TextField,
  DateField,
  ChipField,
  SelectInput,
  BooleanInput,
  Show,
  SimpleShowLayout,
  TopToolbar,
  CreateButton,
  ExportButton,
  Toolbar,
  SaveButton,
  SimpleForm,
  Create,
  useNotify,
  TextInput,
} from 'react-admin'

import { inviteUser } from '../dataProvider'

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="Invite User" />
    <ExportButton />
  </TopToolbar>
)

const InviteToolbar = () => {
  return (
    <Toolbar>
      <SaveButton label="Invite User" />
    </Toolbar>
  )
}

export const UserInvite = () => {
  const notify = useNotify()
  const onInvite = async (params) => {
    await inviteUser(params)

    notify('User will receive invitation on the email.')
  }

  return (
    <Create>
      <SimpleForm toolbar={<InviteToolbar />} onSubmit={onInvite}>
        <TextInput source="email" type="email" />
        <SelectInput
          source="role"
          choices={[
            { id: 'ADMIN', name: 'Admin' },
            { id: 'USER', name: 'user' },
          ]}
        />
      </SimpleForm>
    </Create>
  )
}

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const UserList = ({ isEdit, isDelete }) => (
  <List
    actions={<ListActions />}
    filters={[
      <SelectInput
        key="filter-role"
        source="role"
        choices={[
          { id: 'USER', name: 'USER' },
          { id: 'ADMIN', name: 'ADMIN' },
        ]}
      />,
      <BooleanInput key="filter-isPremium" source="isPremium" />,
    ]}
  >
    <Datagrid bulkActionButtons={false} rowClick="show">
      <EmailField source="email" />
      <BooleanField source="isEmailVerified" />
      <DateField source="lastAuthenticatedAt" />
      <BooleanField source="isMFARequired" />
      <DateField source="verificationEmailSentAt" />
      <ChipField source="role" />
      <TextField source="invitedBy" />
      <BooleanField source="isGroupSet" />
      <BooleanField source="isPremium" />
      <BooleanField source="isPaymentRequired" />
      <DateField source="premiumUpdateAt" />
    </Datagrid>
  </List>
)

export const UserShow = () => (
  <Show>
    <SimpleShowLayout>
      <EmailField source="email" />
      <BooleanField source="isEmailVerified" />
      <DateField source="lastAuthenticatedAt" />
      <BooleanField source="isMFARequired" />
      <DateField source="verificationEmailSentAt" />
      <ChipField source="role" />
      <TextField source="invitedBy" />
      <BooleanField source="isGroupSet" />
      <BooleanField source="isPremium" />
      <BooleanField source="isPaymentRequired" />
      <DateField source="premiumUpdateAt" />
      <TextField source="requestedChangeToGroupId" />
    </SimpleShowLayout>
  </Show>
)
